import React, {ReactNode} from 'react';
import {generatePath} from 'react-router-dom';
import {t} from '@lingui/core/macro';

import BackButton from 'shared/ui/IconButton/BackButton';

import styles from './ListToolbar.module.scss';

interface IListToolbarProps {
    title: string,
    count?: number,
    maxCount?: number,
    summary?: ReactNode,
    backUrl?: string,
    createButton?: ReactNode,
    hideCreateButtonOnMobile?: boolean,
    actions?: ReactNode,
    children?: ReactNode,
}

const ListToolbar: React.FC<IListToolbarProps> = ({
    title,
    count,
    maxCount,
    summary,
    backUrl,
    createButton,
    hideCreateButtonOnMobile,
    actions,
    children,
}) => {
    return (
        <div className={styles.container}>
            <div className={styles.blockTitle}>
                {backUrl &&
                    <BackButton
                        to={generatePath(backUrl)}
                        text={t`Назад`}
                        className={styles.backButton}
                    />
                }
                <h3 className={styles.title}>
                    {title}{count !== undefined && `: ${count}`}
                    {maxCount !== undefined && <span className={styles.maxCount}> / {maxCount}</span>}
                </h3>

                {summary}

                {createButton && (
                    <div
                        className={hideCreateButtonOnMobile ? styles.createButtonHiddenMobile : styles.createButtonCell}
                    >
                        {createButton}
                    </div>
                )}
            </div>

            {actions && <div className={styles.actionsCell}>{actions}</div>}

            {children && <div className={styles.childrenCell}>{children}</div>}
        </div>
    );
};

export default ListToolbar;
